import { faAlarmClock } from '@fortawesome/pro-regular-svg-icons';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { formatCadenceCompact } from './scheduleFormat.ts';
import Button from '../../../core/components/Button.tsx';
import { withIcon } from '../../../core/components/Icon.tsx';
import Tooltip from '../../../core/components/Tooltip.tsx';

const ClockIcon = withIcon(faAlarmClock);

export const ScheduleHeaderButton = ({ schedule, onClick }: { schedule: any; onClick: () => void }) => {
    const { t } = useTranslation('chat');
    // an ended schedule doesn't run any more, like a paused one
    const running = schedule.active && !schedule.isEnded;
    // always the clock: the tooltip names the action and the schedule's status
    const label = schedule.autoPaused
        ? t('automations.header.autoPaused')
        : running
          ? t('automations.header.scheduled', { cadence: formatCadenceCompact(t, schedule) })
          : t('automations.header.paused');

    return (
        <Tooltip content={label}>
            <Button variant="ghost" className="px-2" aria-label={label} onClick={onClick}>
                <ClockIcon />
            </Button>
        </Tooltip>
    );
};
